import { render, staticRenderFns } from "./PreApproveHistory.vue?vue&type=template&id=0ab99b3b&scoped=true&"
import script from "./PreApproveHistory.vue?vue&type=script&lang=js&"
export * from "./PreApproveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab99b3b",
  null
  
)

export default component.exports